import React, { useContext, useEffect, useState } from 'react';
import { withRouter, Redirect } from 'react-router-dom';
import { InMemoryCache } from '@apollo/client/cache';
import { createHttpLink } from 'apollo-link-http';
import { ApolloClient } from '@apollo/client/core';
import envConfig from '@nile/home/src/Config/env';
import gql from 'graphql-tag';
import { Card, AppProvider } from '@shopify/polaris';
import { GET_INVOICE, GET_CLIENT, GET_CLIENT_INVOICE } from '@nile/graphql';
import { GET_MSP_COMPANY } from '@nile/banyan/src/Graphql/Mutations/msp';
import { useQuery, useMutation } from '@apollo/client';
import shortid from 'shortid';
import styled from 'styled-components';
import {
  B1,
  HeaderTag,
  DisabledTag,
  getHeaderValue,
  getDownloadURL,
  ALL_MODULES,
  Loader
} from '@nile/components';
import InvoiceDetailsPDF from '@nile/components/src/Pages/InvoiceDetailsPdf';
import QuoteDetailsPDF from '@nile/components/src/Pages/QuoteDetailsPdf';

const PDFWrap = styled.div`
  .Polaris-Page__Content {
    overflow: unset !important;
  }
`;

const cache = new InMemoryCache({
  addTypename: false
});

function QuoteTemplate(props) {
  const params = new URLSearchParams(props.location.search);
  const clientId = params.get('clientId');
  const quoteId = params.get('quoteId');
  const token = params.get('token');
  const AccountClient = new ApolloClient({
    cache,
    link: createHttpLink({
      uri: localStorage?.getItem('apiDomain') + envConfig.accountsGateway,
      credentials: 'include',
      headers: {
        ...getHeaderValue(),
        authorization: `Bearer nl-${token}`
      }
    }),
    connectToDevTools: true
  });
  return (
    <AppProvider>
      <Quote
        clientId={clientId}
        quoteId={quoteId}
        token={token}
        AccountClient={AccountClient}
      />
    </AppProvider>
  );
  // return (
  //   <Quote
  //     //   clientId={clientId}
  //     quoteId={'1045340254706376704'}
  //     //   token={token}
  //     //   AccountClient={AccountClient}
  //   />
  // );
}
function Quote(props) {
  const { clientId, quoteId, token, AccountClient } = props;

  const {
    loading: companyLoading,
    error: companyError,
    data: mspcompany
  } = useQuery(GET_MSP_COMPANY, {
    client: AccountClient,
    fetchPolicy: 'network-only'
  });
  useEffect(() => {
    document.body.style.overflow = 'auto';
  }, []);
  if (companyLoading) return <Loader />;
  const company = mspcompany?.getMSPCompany;

  return (
    <PDFWrap className="vignesh">
      <AppProvider>
        <QuoteDetailsPDF
          quoteId={quoteId}
          accountClient={AccountClient}
          company={mspcompany?.getMSPCompany}
        />
      </AppProvider>
    </PDFWrap>
  );
}

export default withRouter(QuoteTemplate);
